import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {OktaUser, User, USER_PREFERENCE_KEY, UserPreference} from '../models/user';
import {AuthState, OktaAuth} from '@okta/okta-auth-js';
import {OktaAuthStateService} from '@okta/okta-angular';
import {catchError, filter, map, switchMap} from 'rxjs/operators';
import {from, Observable, of} from 'rxjs';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {PageAccessStorageService} from '../store/page-access-storage.service';
import {AcmHttpResponse} from '../models/acm-http';


@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private oktaAuth: OktaAuth,
              private httpClient: HttpClient,
              private pageAccessStorageService: PageAccessStorageService,
              private oktaAuthStateService: OktaAuthStateService) {
  }

  public getOktaUserInfo(): Observable<OktaUser> {
    let currentUser: OktaUser = null;

    return from(this.oktaAuthStateService.authState$)
      .pipe(
        filter((authState: AuthState) => !!authState && !!authState.isAuthenticated),
        switchMap(() => {
          if (this.pageAccessStorageService.pageAccessInfo && this.pageAccessStorageService.pageAccessInfo.oktaInfo) {
            return of(this.pageAccessStorageService.pageAccessInfo.oktaInfo);
          }

          return this.oktaAuth.getUser();
        }),
        map((user): OktaUser => {
          currentUser = Object.assign({}, user);
          currentUser.isUserAdmin = environment.superAdminsEmails.has(user.email);
          return currentUser;
        })
      );
  }

  public getUser(): Observable<User> {
    return this.httpClient.get(`${environment.apiUrl}user`)
      .pipe(
        catchError(() => of(null))
      ) as Observable<User>;
  }

  public getUserPreferenceByKeys(userId: number, userPreferenceKeys: string): Observable<UserPreference[]> {
    return this.httpClient.get(`${environment.apiUrl}user/${userId}/preferences/?userPreferenceKeys=${userPreferenceKeys}`)
      .pipe(
        catchError(() => of(null))
      ) as Observable<UserPreference[]>;
  }

  public saveUserPreferenceByKey(userId: number, userPreferenceKey: USER_PREFERENCE_KEY, preferenceValue: string): Observable<AcmHttpResponse> {
    return this.httpClient.post(
      `${environment.apiUrl}user/${userId}/preferences/${userPreferenceKey}`,
      preferenceValue,
      {observe: 'response'})
      .pipe(
        map((response: HttpResponse<{}>): AcmHttpResponse => ({statusCode: response.status}))
      ) as Observable<AcmHttpResponse>;
  }
}
